import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { formatMoney, formatMoneyShorten, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_ALL,
	STR_BULK_SMS,
	STR_BULK_WHATSAPP,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLIENTS,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_CUSTOMERS,
	STR_EFILING,
	STR_LEADS,
	STR_LOGOUT,
	STR_MAIN_MENU,
	STR_MY_COACH,
	STR_MY_STUDENTS,
	STR_NO_RECORD,
	STR_PAYMENT_SETTINGS,
	STR_PAYROLL,
	STR_PERSONAL_SETTINGS,
	STR_PURCHASES,
	STR_REGISTER_NEW,
	STR_SALES,
	STR_SEARCH_HERE,
	STR_SET_CURRENCY,
	STR_STOCK,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSearch, MdSupportAgent, MdTranslate, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import sales_icon from '../assets/sales_icon.png'
import purchases_icon from '../assets/purchases_icon.png'
import payroll_icon from '../assets/payroll_icon.png';
import stock_icon from '../assets/stock_icon.png';
import clients_icon from '../assets/clients_icon.png';
import efiling_icon from '../assets/efiling_icon.png';
import whatsapp_icon from '../assets/whatsapp_icon.png';
import sms_icon from '../assets/sms_icon.png'
import CurrentBusinessWidget from "../ones/CurrentBusinessWidget";
import TabbedView from "../components/TabbedView";
import OneClient from '../ones/OneClient';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [customers, setCustomers] = useState([]);
	const [leads, setLeads] = useState([]);
	const [filter, setFilter] = useState('');

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllClients(),
		])
		setReady(true);
	}

	function groupClients() {
		let _customers = [];
		let _leads = [];

		if(appContext.allClients) {
			_customers = appContext.allClients.filter((item, i) => item.level === 'customer');
			_leads = appContext.allClients.filter((item, i) => item.level === 'lead')
		}

		setCustomers(_customers);
		setLeads(_leads);
	}

	function applyFilter(items) {
		if(items && items.length > 0 && filter && filter.trim().length > 0) {
			//filter here

			const filtered = items.filter((item, i) => {
				return (
					String(item.name).toLowerCase().indexOf(String(filter).toLowerCase()) > -1 ||
					String(item.phone).toLowerCase().indexOf(String(filter).toLowerCase()) > -1 ||
					String(item.whatsAppNumber).toLowerCase().indexOf(String(filter).toLowerCase()) > -1 ||
					String(item.tin).toLowerCase().indexOf(String(filter).toLowerCase()) > -1 ||
					String(item.vrn).toLowerCase().indexOf(String(filter).toLowerCase()) > -1 ||
					String(item.email).toLowerCase().indexOf(String(filter).toLowerCase()) > -1
				) 
			});

			return filtered;

		} else {
			return items;
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		groupClients();
	}, [ appContext.allClients ])

	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<CurrentBusinessWidget/>
						</div>

						{
							(appContext.currentBusiness) ?
							<>

								<div className="col-md-12">
									<h6 className="main-section-title">
										{STR_CLIENTS[appContext.language]}
									</h6>
								</div>
								
								<div className="col-md-12">
									<div className="text-end mb-4">
										<button
											className="btn btn-sm btn-padded btn-rounded btn-primary mt-4"
											onClick={() => {
												appContext.navTo({
													item: 'view',
													subItem: 'register-client',
												})
											}}
										>
											{STR_REGISTER_NEW[appContext.language]}
										</button>
									</div>
								</div>

								<div className="col-12 mt-3 mb-2">
									<div className="mStatCard">
										<h6
											className="mNumber"
										>
											{formatMoneyShorten(appContext.allClients?.length || 0)}
										</h6>

										<h6
											className="mTitle"
										>
											{STR_ALL[appContext.language]}
										</h6>
									</div>
								</div>

								<div className="col-6 mt-3 mb-3">
									<div className="mStatCard">
										<h6
											className="mNumber"
										>
											{formatMoneyShorten(customers?.length || 0)}
										</h6>

										<h6
											className="mTitle"
										>
											{STR_CUSTOMERS[appContext.language]}
										</h6>
									</div>
								</div>

								<div className="col-6 mt-3 mb-3">
									<div className="mStatCard">
										<h6
											className="mNumber"
										>
											{formatMoneyShorten(leads?.length || 0)}
										</h6>

										<h6
											className="mTitle"
										>
											{STR_LEADS[appContext.language]}
										</h6>
									</div>
								</div>

								<div className="col-md-12 mt-3 mb-3">

									<div className="d-flex justify-content-end mt-3 mb-4">
										<div
											className="input-group"
											style={{
												maxWidth: "200px"
											}}
										>
											<span
												className="input-group-text font-bold text-secondary"
												style={{
													fontSize: "18px"
												}}
											>
												<MdSearch size={24}/>
											</span>
											<input
												className="form-control"
												onChange={(e) => setFilter(e.target.value)}
												value={filter}
												placeholder={STR_SEARCH_HERE[appContext.language]}
												type="text"
												
											/>
										</div>
									</div>

									<TabbedView
										tabs={[
											{
												id: "all-tab",
												label: STR_ALL[appContext.language],
												content: (
													<div
														className="mt-3 mb-3"
													>
														{
															(
																appContext.allClients &&
																applyFilter(appContext.allClients).length > 0
															) 
															?
															applyFilter(appContext.allClients).map((item, i) => {
																return (
																	<OneClient data={item} key={i} />
																)
															})
															:
															<h6>
																{STR_NO_RECORD[appContext.language]}
															</h6>
														}
													</div>
												)
											},
											{
												id: "customers-tab",
												label: STR_CUSTOMERS[appContext.language],
												content: (
													<div
														className="mt-3 mb-3"
													>
														{
															(
																customers &&
																applyFilter(customers).length > 0
															) 
															?
															applyFilter(customers).map((item, i) => {
																return (
																	<OneClient data={item} key={i} />
																)
															})
															:
															<h6>
																{STR_NO_RECORD[appContext.language]}
															</h6>
														}
													</div>
												)
											},
											{
												id: "leads-tab",
												label: STR_LEADS[appContext.language],
												content: (
													<div
														className="mt-3 mb-3"
													>
														{
															(
																leads &&
																applyFilter(leads).length > 0
															) 
															?
															applyFilter(leads).map((item, i) => {
																return (
																	<OneClient data={item} key={i} />
																)
															})
															:
															<h6>
																{STR_NO_RECORD[appContext.language]}
															</h6>
														}
													</div>
												)
											}
										]}
									/>
								</div>

								

							</>
							:""
						}
						
					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}